const {Component} = require("react");
const Image = require("app/components/mixins/LazyImg");
const router = require("app/services/router");

class Location extends Component {

	get value() {
		return this.inputElement.value;
	}

	set value(value) {
		this.inputElement.value = value;
	}

	componentDidUpdate(prevProps, prevState, snapshot){
		if(prevProps.defaultValue != this.props.defaultValue){
			this.inputElement.value = this.props.defaultValue;
		}
	}

	render() {
		return (
			<div className="location-field">
				<Image src={router.url("img/icons/place.png")} name="Location" loader={false} afterload={'true'}/>
				<input ref={el => this.inputElement = el} type="text" {...this.props} />
			</div>
		);
	}

}

module.exports = Location;